import { AgmCoreModule } from '@agm/core';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { HttpClientModule } from '@angular/common/http';
import { Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import 'hammerjs';
import { NgxPermissionsModule } from 'ngx-permissions';
import { environment } from './../environments/environment';
import { AppComponent } from './app.component';
import { FuseNavigationService } from './core/components/navigation/navigation.service';
import { SharedModule } from './core/modules/shared.module';
import { FuseConfigService } from './core/services/config.service';
import { FuseSplashScreenService } from './core/services/splash-screen.service';
import { LocatorService } from './locator.service';
import { FuseChatComponent } from './main/content/pages/chat/chat.component';
import { FuseChatModule } from './main/content/pages/chat/chat.module';
import { PagesModule } from './main/content/pages/pages.module';
import { FuseSampleModule } from './main/content/sample/sample.module';
import { FuseMainModule } from './main/main.module';

const appRoutes: Routes = [
    {
        path: '',
        redirectTo: 'pages/home',
        pathMatch: 'full'
    },
    {
        path: '**',
        redirectTo: 'pages/errors/error-404'
    }
];

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        FuseChatModule,
        BrowserModule,
        NgxPermissionsModule.forRoot(),
        HttpClientModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, { useHash: true }),
        SharedModule,
        TranslateModule.forRoot(),
        FuseMainModule,
        PagesModule,
        FuseSampleModule,
        AgmCoreModule.forRoot({
            apiKey: environment.googleMapsApiKey,
            libraries: [
                'geometry',
                'places'
            ]
        }),
        AgmSnazzyInfoWindowModule
    ],
    providers: [
        FuseSplashScreenService,
        FuseConfigService,
        FuseNavigationService,
    ],
    entryComponents: [
        FuseChatComponent
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule {
    constructor(private injector: Injector) {
        LocatorService.injector = this.injector;
    }
    
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts